<template>
	<div
		:id="`document-list-${_uid}`"
		:class="[
			'c-block-list-document-list-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`document-list-${_uid}`"
			:title="title"
		>
			<BaseH2 class="text-primary-button mb-sm" v-text="title" />
		</LongReadTarget>

		<div
			v-if="documents && documents.length"
			class="bg-primary-light rounded-lg p-md"
		>
			<LinkTile
				v-for="(document, index) in documents"
				:key="index"
				:aria-labelledby="`document-${_uid}-${index}`"
				class="group relative flex justify-between pb-sm last:pb-0"
				:download="getFilenameFromUrl(document.path)"
				:to="document.path"
				target="_blank"
			>
				<div class=">=768:items-center">
					<BaseH3 :id="`document-${_uid}-${index}`" class="inline">{{
						document.name
					}}</BaseH3>
					<div class="<768:hidden mx-8 flex-shrink-0 inline">
						{{
							'(' +
							document.extension.toUpperCase() +
							', ' +
							getByteSize(document.size) +
							')'
						}}
					</div>
				</div>
				<BaseButton tag="div" class="w-fit self-center ml-md">
					<template #icon>
						<SvgDownloadIcon class="w-16 h-16 text-white" />
					</template>
				</BaseButton>
			</LinkTile>
		</div>
	</div>
</template>

<script>
import LinkTile from '~/citi-baseline/components/LinkTile';
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import SvgDownloadIcon from '~/assets/svgs/download-icon.svg?inline';

export default {
	name: 'BlockListDocumentListCustom',
	components: { LinkTile, LongReadTarget, SvgDownloadIcon },
	inheritAttrs: false,

	props: {
		title: String,
		documents: Array,
	},
	methods: {
		getShorterDocumentName(name) {
			if (name.length < 50) {
				return name;
			} else {
				return name.slice(0, 50) + ' ...';
			}
		},
		getFilenameFromUrl(path) {
			const split = path.split('/');
			return split[split.length - 1];
		},
		getByteSize(bytes) {
			if (bytes >= 1073741824) {
				// 1024 * 1024 * 1024
				bytes = Math.round(bytes / 1073741824) + ' GB';
			} else if (bytes >= 1048576) {
				// 1024 * 1024
				bytes = Math.round(bytes / 1048576) + ' MB';
			} else if (bytes >= 1024) {
				// 1024 * 1
				bytes = Math.round(bytes / 1024) + ' KB';
			} else if (bytes > 1) {
				bytes = Math.round(bytes) + ' bytes';
			} else if (bytes === 1) {
				bytes = bytes + ' byte';
			} else {
				bytes = '0 bytes';
			}

			return bytes;
		},
	},
};
</script>
